type DeleteAttachmentRequest = (blobPath: string) => Promise<unknown>
type AttachmentNodeLike = {
  id: string
  type?: string
  data?: {
    blobPath?: unknown
  }
}

export function getAttachmentBlobPath(blobPath: unknown): string | null {
  if (typeof blobPath !== "string") return null
  const trimmed = blobPath.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function deleteWorkflowAttachmentViaApi(blobPath: string): Promise<unknown> {
  return import("@/lib/api-client").then(({ api }) =>
    api.delete("/explorer/workflow/attachment", {
      data: { blobPath },
    })
  )
}

export async function cleanupWorkflowAttachment(
  blobPath: unknown,
  deleteRequest: DeleteAttachmentRequest = deleteWorkflowAttachmentViaApi
): Promise<boolean> {
  const normalizedBlobPath = getAttachmentBlobPath(blobPath)
  if (!normalizedBlobPath) return false

  await deleteRequest(normalizedBlobPath)
  return true
}

export function getRemovedAttachmentBlobPaths(
  previousNodes: AttachmentNodeLike[],
  nextNodes: AttachmentNodeLike[]
): string[] {
  const nextIds = new Set(nextNodes.map((node) => node.id))
  return previousNodes
    .filter((node) => node.type === "attachment" && !nextIds.has(node.id))
    .map((node) => getAttachmentBlobPath(node.data?.blobPath))
    .filter((blobPath): blobPath is string => Boolean(blobPath))
}

export async function cleanupRemovedAttachmentNodes(
  previousNodes: AttachmentNodeLike[],
  nextNodes: AttachmentNodeLike[],
  deleteRequest: DeleteAttachmentRequest = deleteWorkflowAttachmentViaApi
): Promise<void> {
  const blobPaths = getRemovedAttachmentBlobPaths(previousNodes, nextNodes)
  await Promise.allSettled(
    blobPaths.map((blobPath) => cleanupWorkflowAttachment(blobPath, deleteRequest))
  )
}
